import { del } from '@eika-infrastruktur/request';

import type { AccountNotification, AccountNotificationId, AccountNotificationRequest } from '../generated-types';
import { CONTEXT_PATH } from './index';
import { get, post, put } from './request';

export const SERVICE_PATH = 'rest/resource/account-notifications';

export const getAccountNotifications = (): Promise<AccountNotification[]> =>
    get<AccountNotification[]>(`${CONTEXT_PATH}/${SERVICE_PATH}`);

export const createAccountNotification = (request: AccountNotificationRequest): Promise<AccountNotification> =>
    post<AccountNotification>(`${CONTEXT_PATH}/${SERVICE_PATH}`, request);

export const updateAccountNotification = (request: AccountNotification): Promise<AccountNotification> =>
    put<AccountNotification>(`${CONTEXT_PATH}/${SERVICE_PATH}/${request.id}`, request);

export const deleteAccountNotification = (id: AccountNotificationId): Promise<void> =>
    del<void>(`${CONTEXT_PATH}/${SERVICE_PATH}/${id}`);
